<template>
  <div class="w-full bg-white h-full">
    <div class="document-detail-header flex lg:flex-row flex-col justify-between lg:py-4 h-auto lg:h-16 lg:items-center">
      <div v-if="document.tipo_formato != 'eform'"
        class="document-actions order-3 flex-wrap lg:order-none flex lg:justify-start justify-between w-full lg:pt-0 lg:w-1/3">
        <div class="lg:hidden flex w-full">
          <button data-vs-button="show-opts" class="text-zt-primary-200 outline-none ml-auto pb-2"
            @click="isOptionsActive = !isOptionsActive">
            <span class="pr-1 text-zt-md">{{ $t("message.documentComponent.opcions") }}</span>
            <zt-icon :name="isOptionsActive ? 'caret-up' : 'caret-down'" />
          </button>
        </div>
        <div :class="[isMoreOptionsActive, isMobile ? 'pb-4' : '', 'document-actions__buttons']">
          <zt-button data-vs-button="open-document"
            v-if="isActionActive(myActions.signingDisagreement)"
            @click="openSignDocument(false)" class="document-actions__button text-zt-md mr-4" outlined>{{
              $t(
                'message.documentVisualizerComponent.signButtons.signDissatisfied'
              )
            }}</zt-button>
          <zt-button data-vs-button="request-rrhh"
            v-if="isActionActive(myActions.consultHR) && hasUserActive" class="document-actions__button ml-auto text-zt-md"
            outlined @click="activeRRHH = !activeRRHH">{{
              $t("message.documentVisualizerComponent.signButtons.rrhhConsult") }}</zt-button>
        </div>
      </div>
      <div class="document-toolbar order-1 lg:order-none ml-auto lg:ml-0 w-full flex justify-center lg:w-1/3">
        <div class="flex justify-center items-center pt-2 pb-3 lg:py-0">
          <div class="mr-6 hidden lg:block">
            <button data-vs-button="zoom-out" class="text-zt-primary-200 text-zt-xl mr-4 outline-none" @click="zoomOut">
              <zt-icon name="zoom-out" />
            </button>
            <button data-vs-button="zoom-in" class="text-zt-primary-200 text-zt-xl outline-none" @click="zoomIn">
              <zt-icon name="zoom-in" />
            </button>
          </div>
          <div class="">
            <button data-vs-button="last-image" class="inline-block outline-none" @click="getLastImage">
              <zt-icon name="angle-left" />
            </button>
            <p v-if="documentFileStore.totalPages" class="inline-block px-1 pt-1">
              {{ page }} / {{ documentFileStore.totalPages }}
            </p>
            <button data-vs-button="next-image" @click="getNextImage" class="inline-block outline-none">
              <zt-icon name="angle-right" />
            </button>
            <button data-vs-button="fullscreen" class="text-zt-primary-200 text-zt-xl outline-none"
              @click="setFullScreen">
              <zt-icon name="expand-arrows" />
            </button>
          </div>
        </div>
      </div>
      <div class="document-sign order-2 lg:order-none text-right w-full lg:w-1/3 document--group lg:pb-0">
        <zt-button data-vs-button="sign-document" class="w-full lg:w-auto" @click="openSignDocument(true)">{{
          $t("message.documentVisualizerComponent.signButtons.signDocument") }}</zt-button>
      </div>
    </div>
    <zt-modal :active="activeRRHH" @close="activeRRHH = false">
      <template slot="modal-header">
        <h2 class="p-4 text-zt-xl text-center">
          {{
            $t(
              'message.documentVisualizerComponent.consultRRHHModal.consultRRHHTitle'
            )
          }}
        </h2>
      </template>
      <div class="p-4">
        <textarea data-vs-textarea="message" v-model="message"
          class="w-full outline-none border p-2 border-solid border-zt-dark-300 resize-none" rows="5" :placeholder="$t(
            'message.documentVisualizerComponent.consultRRHHModal.submitConsultRRHH'
          )
            "></textarea>
      </div>
      <template slot="modal-footer">
        <div class="zt-modal-footer flex justify-center lg:justify-between items-center p-4">
          <zt-button data-vs-button="cancel" class="mr-1" outlined @click="
            message = ''
          activeRRHH = false
            ">{{ $t("message.documentVisualizerComponent.signDialog.cancelButton") }}</zt-button>
          <zt-button data-vs-button="request-rrhh-message" @click="consultToRRHH" class="ml-1"
            :disabled="isCompleteMessage" :loader="loadingConsult"
            :loaderTxt="$t('message.documentVisualizerComponent.sending')">{{
              $t("message.documentVisualizerComponent.consultRRHHModal.consult") }}</zt-button>
        </div>
      </template>
    </zt-modal>
    <zt-modal max-width="450px" :show-button-close="false" class="rounded" :active="activeSign" @close="cleanModal">
      <template slot="modal-header">
        <div class="w-full">
          <p class="p-4 text-zt-lg font-medium text-white">
            {{
              confirmDocument
                ? $t(
                  'message.documentVisualizerComponent.signDialog.signConfort'
                )
                : $t(
                  'message.documentVisualizerComponent.signDialog.signNotConfort'
                )
            }}
          </p>
        </div>
      </template>
      <div class="px-4 pb-4">
        <div v-if="!confirmDocument && dissatisfiedMessage != ''" class="flex py-3 items-center border-bottom">
          <div class="">
            <zt-icon name="info-circle-alt text-zt-primary-100" style="font-size: 48px;" />
          </div>
          <p class="line-clamp overflow-hidden rounded-zt-sm text-zt-dark-300" v-html="dissatisfiedMessage"></p>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form id="sign-document-form" @submit.prevent="handleSubmit(signDocument)" ref="notConfortReasonForm">
            <v-select data-vs-select="reasons" v-if="!confirmDocument" v-model="reasonSelected"
              :items="signNotConfortReasons" item-text="text" item-value="value" :placeholder="notConfortPlaceHolder"
              :rules="notReasonRules" return-object />

            <div>
              <p class="py-4 confirm--label">
                {{
                  $t(
                    'message.documentVisualizerComponent.signDialog.inputPassword'
                  )
                }}
              </p>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <zt-input data-vs-input="password" type="password" outlined label="Contraseña"
                  v-model="passwordModal.userPass" :color="invalid ? 'danger' : 'primary'" />
                <span v-show="errors[0]" class="text-zt-danger">{{
                  $t("message.loginComponent.validations.passwordRules.requirePass") }}</span>
              </ValidationProvider>
              <div class="pt-2" v-if="user.sso">
                <router-link data-vs-link="go-forgotpassword" class="underline text-zt-primary-100"
                  to="/forgotpassword">
                  {{ $t('message.documentVisualizerComponent.forgetPassword') }}
                </router-link>
              </div>
            </div>
            <div v-if="
              confirmDocument && isActionActive(myActions.sendDocumentSigned)
            ">
              <zt-check-box data-vs-check-box="show-input-email" v-model="showInputEmail"><span
                  class="confirm--label">{{
                    $t("message.homeComponent.sections.send_signed_document") }}</span></zt-check-box>

              <div class="pt-4" v-if="showInputEmail">
                <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                  <zt-input data-vs-input="email" outlined label="Mail" ref="email" v-model="userEmail"
                    :color="invalid ? 'danger' : 'primary'" />
                  <span v-show="errors[0]" class="text-zt-danger">
                    {{ $t("message.homeComponent.sections.valid_email_requerid") }}
                  </span>
                </ValidationProvider>
                <p class="text-zt-md text-zt-dark-400 pt-2">
                  {{ $t("message.homeComponent.sections.send_valid_email") }}
                </p>
              </div>
            </div>
          </v-form>
        </ValidationObserver>
      </div>
      <template slot="modal-footer">
        <div class="zt-modal-footer flex justify-end items-center p-4 confirm--footer">
          <zt-button class="mr-1" outlined @click="cleanModal">{{ $t("message.DownloadAllDocuments.cancel")
            }}</zt-button>
          <zt-button data-vs-button="submit" :disabled="disabledSend" type="submit" form="sign-document-form"
            class="ml-1">{{
              $t('message.documentComponent.SignedDocuments.sendDocument')
            }}</zt-button>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Signature from '@/apiClient/Signatures'
import { useWindowResize } from '@sichern/ui-elements'
import { some } from 'lodash'
import Company from '@/apiClient/Company'

export default {
  name: 'DocumentDetailPDF',
  props: [
    'getNextImage',
    'getLastImage',
    'iddoc',
    'refreshSignedDocument',
    'page'
  ],
  inject: ['documentFileStore', 'setFile', 'zoomIn', 'zoomOut'],
  data() {
    return {
      myActions: {
        signingDisagreement: 55,
        consultHR: 52,
        sendDocumentSigned: 98
      },
      activeRRHH: false,
      confirmDocument: false,
      reasonSelected: '',
      activeSign: false,
      message: '',
      showDownloadOpts: false,
      passwordModal: {
        showPassword: false,
        userPass: ''
      },
      signatures: '',
      idApp: '',
      isOptionsActive: false,
      notConfortPlaceHolder: this.$t(
        'message.documentVisualizerComponent.signNotConfort.select'
      ),
      notReasonRules: [
        v => !!v || this.$t('message.loginComponent.validations.reasonRules')
      ],
      signNotConfortReasons: [
        {
          value: 3,
          text: this.$t(
            'message.documentVisualizerComponent.signNotConfort.reasons.three'
          )
        },
        {
          value: 4,
          text: this.$t(
            'message.documentVisualizerComponent.signNotConfort.reasons.four'
          )
        },
        {
          value: 5,
          text: this.$t(
            'message.documentVisualizerComponent.signNotConfort.reasons.five'
          )
        },
        {
          value: 6,
          text: this.$t(
            'message.documentVisualizerComponent.signNotConfort.reasons.six'
          )
        }
      ],
      imageRef: '',
      windowSize: useWindowResize(this),
      showInputEmail: true,
      userEmail: '',
      disabledSend: false,
      dissatisfiedMessage: '',
      loadingConsult: false
    }
  },
  created() {
    this.signatures = new Signature()
    this.userEmail = this.getUserEmail
    this.company = new Company()
    this.getDissatisfiedMessage()
  },
  computed: {
    ...mapState(['user', 'timerSweetAlert', 'actions']),
    ...mapState('documents', ['document']),
    ...mapGetters(['getUserEmail', 'isUserActive']),
    isActionActive() {
      return actionId => some(this.actions, { id: actionId.toString() })
    },
    hasUserActive() {
      return this.isUserActive
    },
    isCompleteMessage() {
      return this.message ? false : true
    },
    isMobile() {
      return this.windowSize.width < 1023
    },
    isMoreOptionsActive() {
      if (this.windowSize.width < 1024) {
        return this.isOptionsActive ? 'flex' : 'hidden'
      }

      return 'flex'
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
  },
  methods: {
    ...mapActions('documents', ['updateDocumentSelected']),
    openSignDocument(value) {
      this.confirmDocument = value
      this.activeSign = true
    },
    cleanModal() {
      this.passwordModal.userPass = ''
      this.activeSign = false
      this.showInputEmail = true
      this.userEmail = this.getUserEmail
      this.reasonSelected = ''
    },
    async consultToRRHH() {
      try {
        this.loadingConsult = true
        await this.signatures.consultRRHHOnSign(
          this.user.aplicacion.id,
          this.document.id,
          this.message
        )
        this.loadingConsult = false
        await this.$swal({
          type: 'success',
          title: this.$t(
            'message.documentVisualizerComponent.consultSuccessRRHH'
          ),
          timer: this.timerSweetAlert,
          showConfirmButton: false
        })

        this.activeRRHH = !this.activeRRHH
        this.message = ''
      } catch (error) {
        await this.$swal({
          type: 'error',
          title:
            error.response.data.code === 400
              ? this.$t(`message.errorReference.err400`)
              : this.$t(`message.errorReference.${error.response.data.code}`),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
        })
        this.loadingConsult = false
      }
    },

    async signDocument() {
      try {
        if (this.$refs.notConfortReasonForm.validate()) {
          this.disabledSend = true
          if (this.confirmDocument) {
            await this.updateDocumentSelected({
              status: 'FIRMADO CONFORME',
              body: {
                passphrase: this.passwordModal.userPass,
                sendDocument: this.showInputEmail ? 1 : 0,
                email: this.showInputEmail ? this.userEmail : ''
              },
              inbox: this.isInboxDocumentActivated
            })
          } else {
            await this.updateDocumentSelected({
              status: 'FIRMADO DISCONFORME',
              body: { passphrase: this.passwordModal.userPass },
              reason: this.reasonSelected.value,
              inbox: this.isInboxDocumentActivated
            })
          }
          this.setFile({
            idApp: this.user.aplicacion.id,
            idDoc: this.document.id
          })
          this.cleanModal()
          this.reasonSelected = ''
          this.disabledSend = false
          this.refreshSignedDocument()
          await this.$swal({
            type: 'success',
            title: this.$t('message.documentVisualizerComponent.firmSuccess'),
            timer: this.$store.getters.getTimerSweetAlert,
            showConfirmButton: false
          })

          if (this.windowSize.width < 1024) {
            this.$router.replace({ name: 'documents' })
          }

          this.activeSign = false
        }
      } catch (error) {
        this.disabledSend = false
        this.$swal({
          type: 'error',
          title: this.$t(
            `message.errorReference.${error.response.data.response_v2.code}`
          ),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
        })
      }
    },
    async getDissatisfiedMessage() {
      const result = await this.company.getDissatisfiedSignatureMessage()
      this.dissatisfiedMessage = result.data.data.message
      this.searchMail()
    },
    searchMail() {
      let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g
      let msg = this.dissatisfiedMessage
      const mails_match = this.dissatisfiedMessage.match(regex)
      if (mails_match) {
        mails_match.forEach(element => {
          msg = msg.replace(
            element,
            '<a href="mailto:' + element + '">' + element + '</a>'
          )
        })
        this.dissatisfiedMessage = msg
      }
    },
    setFullScreen() {
      this.$emit('fullscreen-change')
    }
  }
}
</script>
<style scoped>
.outline-none {
  outline: none;
}

.document--group {
  padding-bottom: 8px;
}

.confirm--label {
  color: #4f4f4f;
}

.confirm--footer {
  background-color: #eeeeee;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

@media (min-width: 1024px) and (max-width: 1360px) {
  .document-detail-header {
    height: auto;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto;
    align-items: center;
    column-gap: 16px;
    row-gap: 8px;
  }

  .document-actions {
    width: auto;
    min-width: 0;
  }

  .document-actions__buttons {
    width: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .document-actions__button {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .document-toolbar {
    width: auto;
    justify-self: center;
  }

  .document-sign {
    width: auto;
    margin-left: 0;
    justify-self: end;
    padding-bottom: 0;
  }
}
</style>
